<template>
  <ul class="filters-list">
    <li
      v-for="(filter, index) in availableFilters"
      :key="index"
      class="filters-list__item"
    >
      <button
        class="filters-list__btn"
        :class="{ 'filters-list__btn--is-active': isFilterActive(filter) }"
        @click="toggleFilter(filter)"
      >
        {{ filter }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    availableFilters: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isFilterActive () {
      return filter => this.filters.find(item => item === filter)
    }
  },
  methods: {
    toggleFilter (filter) {
      this.$emit('toggleFilter', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
  .filters-list {
    @include reset-list;

    width: 100%;
    background-color: #fff;
    text-align: center;
    overflow: hidden;

    z-index: z(filters-button) - 1;

    padding: 20px 0 10px;

    &__item {
      margin: 20px 0;
    }

    &__btn {
      @include reset-button;
      @include uppercase-text;
      color: $base-opposite-color;

      transition: color $base-transition;

      &--is-active {
        color: $accent-color;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Settings/FiltersList.vue